import React, { useState } from 'react';
import { Box, SxProps, Tab, Tabs } from '@mui/material';
import { EditorTheme } from '@loyalty/shared-common/template-api-client';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPalette } from '@fortawesome/pro-solid-svg-icons/faPalette';
import { faPlus } from '@fortawesome/pro-solid-svg-icons/faPlus';
import { sxs } from '@qualifio/ui-commons';
import { useTranslation } from 'react-i18next';
import { BLOCKS_ID } from '../../../config';
import { LayoutPanel } from '../../panels/LayoutPanel/LayoutPanel';
import { sidebarStyle } from '../sidebars-style';

export enum EditorGeneralSidebarTabs {
  blocks = 'blocks',
  design = 'design',
}

export interface EditorGeneralSidebarProps {
  sx?: SxProps;
  theme: EditorTheme;
  onThemeChanged: (values: EditorTheme) => void;
}
export function EditorGeneralSidebar({
  sx = {},
  theme,
  onThemeChanged,
}: EditorGeneralSidebarProps): React.ReactElement {
  const { t } = useTranslation();

  const [tab, setTab] = useState<EditorGeneralSidebarTabs>(EditorGeneralSidebarTabs.blocks);

  return (
    <Box sx={sxs(sidebarStyle, sx)}>
      <Tabs value={tab} onChange={(_e, value) => setTab(value)} variant="fullWidth">
        <Tab
          value={EditorGeneralSidebarTabs.blocks}
          icon={<FontAwesomeIcon icon={faPlus} />}
          iconPosition="start"
          label={t('editor.sidebar.tab.blocks')}
        />
        <Tab
          value={EditorGeneralSidebarTabs.design}
          icon={<FontAwesomeIcon icon={faPalette} />}
          iconPosition="start"
          label={t('editor.sidebar.tab.design')}
        />
      </Tabs>

      <Box
        sx={{
          flexGrow: 1,
          flexShrink: 1,
          overflow: 'auto',
        }}
      >
        <Box
          id={BLOCKS_ID}
          sx={{
            display: tab === EditorGeneralSidebarTabs.blocks ? 'block' : 'none',
            padding: 1,
          }}
        />
        <Box
          sx={{
            display: tab === EditorGeneralSidebarTabs.design ? 'block' : 'none',
            padding: 1,
          }}
        >
          <LayoutPanel values={theme} onChange={onThemeChanged} />
        </Box>
      </Box>
    </Box>
  );
}
